import type { OrderChangedEvent } from "@@/shared/orders/order-events/events/order-changed-event/order-changed.event";
import type { OrderConfirmedEvent } from "@@/shared/orders/order-events/events/order-confirmed.event";
import type { OrderCreatedEvent } from "@@/shared/orders/order-events/events/order-created.event";
import type { OrderFullRefundRequestedEvent } from "@@/shared/orders/order-events/events/order-full-refund-requested.event";
import type { OrderPartialRefundRequestedEvent } from "@@/shared/orders/order-events/events/order-partial-refund-requested.event";
import type { OrderPayRequestFulfilledEvent } from "@@/shared/orders/order-events/events/order-pay-request-events/order-pay-request-fulfilled.event";
import type { OrderPaymentFulfilledEvent } from "@@/shared/orders/order-events/events/order-payment-events/order-payment-fulfilled.event";
import type { OrderPaymentRefundFulfilledEvent } from "@@/shared/orders/order-events/events/order-payment-events/order-payment-refund-fulfilled.event";

type SettlementOriginRefund = {
    _type: "SETTLEMENT_ORIGIN";
    type: "REFUND";
    orderCreatedEvent: OrderCreatedEvent;
    orderConfirmedEvent?: OrderConfirmedEvent;
    originEvent: OrderChangedEvent | OrderCreatedEvent;
    refundRequestedEvent:
        | OrderFullRefundRequestedEvent
        | OrderPartialRefundRequestedEvent;
    settlementEvents: OrderPaymentRefundFulfilledEvent[];
};
type SettlementOriginPayment = {
    _type: "SETTLEMENT_ORIGIN";
    type: "PAYMENT";
    orderCreatedEvent: OrderCreatedEvent;
    orderConfirmedEvent?: OrderConfirmedEvent;
    originEvent: OrderChangedEvent | OrderCreatedEvent;
    settlementEvents: (
        | OrderPayRequestFulfilledEvent
        | OrderPaymentFulfilledEvent
    )[];
};

const isSettlementOriginPayment = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is SettlementOriginPayment => {
    return item?.type === "SETTLEMENT_ORIGIN" && item.type === "PAYMENT";
};
const isSettlementOriginRefund = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is SettlementOriginRefund => {
    return item?.type === "SETTLEMENT_ORIGIN" && item.type === "REFUND";
};
const isSettlementOrigin = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is SettlementOrigin => {
    return item?.type === "SETTLEMENT_ORIGIN";
};

type SettlementOrigin = SettlementOriginPayment | SettlementOriginRefund;

export {
    isSettlementOrigin,
    isSettlementOriginPayment,
    isSettlementOriginRefund,
};
export type {
    SettlementOrigin,
    SettlementOriginPayment,
    SettlementOriginRefund,
};
